import Vue from 'vue'
import App from './index.vue'
import router from '@/router/ticket-nth-car2'
import store from '@/store'

import 'amfe-flexible'

import '@/plugins/vant'
import "../../../smartcitysdk1";

import './assets/styles/index.less'
import '@/styles/iconfont.less'


// import { TimeOver } from '@/plugins/utils'
// import jrQrcode from "jr-qrcode"

Vue.config.productionTip = false
//定义全局环境变量
Vue.prototype.isInSmartCityApp = SmartCity.isSmartCityApp()
if (process.env.NODE_ENV === 'development') {
    Vue.prototype.isInSmartCityApp = true;
}

// const VConsole = require('vconsole')
// new VConsole()
if (process.env.NODE_ENV !== 'production'  || window.location.href.indexOf('_debug=jsdev') > -1) {
    const VConsole = require('vconsole')
    new VConsole()
}

// Vue.prototype.shareData = {
//     title: '长兴酒店(民宿)消费券套券',
//     brief: '',
//     contentURL: 'https://prod-app-frontend.zhijianmedia.cn/activity-collection/ticket-nth-car.html',
//     imageLink:
//         'http://oss2upload.oss-cn-hangzhou.aliyuncs.com/read/userId_0_1654089421148_share.png'
// };

if (!Vue.prototype.isInSmartCityApp) {
    window.location.href = 'http://share.plus.hugd.com/app/jump/2022/ticket-nth-car'
}

//微信分享处理
// if (!SmartCity.isSmartCityApp()) {
//     wxShare('湖州人游长兴 | 2022长兴文旅惠民消费券', 'http://oss2upload.oss-cn-hangzhou.aliyuncs.com/changxingCoupon/userId_0_1652948278690_share-bg.png')
// }

new Vue({
    router,
  store,

    render: (h) => h(App),
}).$mount('#app')
